var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"mr-message"},[_c('van-notice-bar',{staticStyle:{"height":"30px"},attrs:{"color":"#FF8100","background":"#fff2e5","left-icon":"volume-o","scrollable":"","text":_vm.text}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }